import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props { children: ReactNode }
interface State { error: Error | null }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Cheesy Apps failed to render", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="grid min-h-screen place-items-center bg-background p-6 text-foreground">
      <section className="w-full max-w-lg rounded-3xl border bg-card p-8 text-center shadow-xl">
        <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
          <AlertTriangle className="size-7" />
        </div>
        <h1 className="mt-6 font-display text-3xl">Cheesy Apps hit a snag</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">Your account and data are safe. Reload the app to retry, or sign out and back in if the problem continues.</p>
        <Button className="mt-7" onClick={() => window.location.reload()}><RefreshCw className="size-4" />Reload Cheesy Apps</Button>
        <details className="mt-6 text-left text-xs text-muted-foreground">
          <summary className="cursor-pointer font-bold">Technical details</summary>
          <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap rounded-xl bg-muted p-3">{this.state.error.message}</pre>
        </details>
      </section>
    </main>;
  }
}
